<template>
  <header class="seminarTabs">
    <v-container>
      <nav class="seminarTabsNav">
        <ul>
          <li :class="{active: isActiveYear(closedIndex, streamingIndex), 'text-xs-center': true}">
            <a href="/seminars">予定</a>
          </li>
          <li :class="{active: streamingIndex, 'text-xs-center': true}">
            <a href="/seminars?type=streaming">Web配信中</a>
          </li>
          <li :class="{active: closedIndex, 'text-xs-center': true}">
            <a href="/seminars?type=closed">開催済み</a>
          </li>
        </ul>
      </nav>
    </v-container>
  </header>
</template>

<script>
  const querystring = require('querystring')

  export default {
    props: [
      'keyword',
      'seminarYears',
      'activeYear',
      'streamingIndex',
      'closedIndex',
    ],

    methods: {
      isActiveYear (closedIndex, streamingIndex) {
        if (closedIndex) {
          return false;
        }

        if (streamingIndex) {
          return false;
        }

        return true;
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  .seminar{
    &Tabs{margin: 0 0 40px;
      & > .container{padding:0;}
      &Nav{@include centerX;
        ul{@include centerX;list-style-type: none;width:100%;padding-left:0;flex-wrap: wrap;
          li{width:120px;
            a{@include centerXY;height:60px;width:100%;font-size:1.5rem;color:$cText;border-bottom:3px solid cBaseDk(8);font-weight: bold;
              &:hover{opacity:1;color:$cKey;border-bottom:3px solid $cKey;}
            }
            &.active{
              a{border-bottom:3px solid $cKey;}
            }
          }
        }
      }
    }
  }
  // Small
  @media screen and (max-width:750px){
    .archivesTitle{margin-bottom: 15px;}
    .seminar{
      &Tabs{position:relative;margin: 0 0 15px !important;
        &Nav{
          ul{
            li{width:100px;margin-bottom:10px;
              a{height:50px;font-size:1.1rem;font-weight: bold;}
            }
          }
        }
      }
    }
  }
</style>
